import type { KnownBusinessEntity } from "@/models/known-business-entity.model"

export function getBusinessRegistrationKey(country?: string, registrationNumber?: string) {
  const normalizedCountry = country?.trim().toUpperCase()
  const normalizedNumber = registrationNumber?.trim()
  if (!normalizedCountry || !normalizedNumber) return undefined
  return `${normalizedCountry}:${normalizedNumber}`
}

export function getKnownBusinessEntityRegistrationKey(entity: KnownBusinessEntity) {
  const registration = entity.registeredBusinessEntity ?? entity
  return getBusinessRegistrationKey(
    registration.countryOfRegistration,
    registration.registrationNumber
  )
}
